import { Theme } from '@constants';

import { isAndroid } from '../../../helpers/Platform';

export const androidMarginTop = (fontSize: number) => (isAndroid ? Theme.px(-fontSize * 0.125) : undefined);
